 @if(Auftrag != null && Patient != null)
 {
<div class="TemplateFiles">
  <h3>Vorlagen</h3>
  <div class="row">
    <div class="col">
      <div class=" mb-3">
        <a href="/Export/Antrag/{{Auftrag.key}}" target="_blank" download="Antrag_{{Patient.versicherungsnummer}}.pdf">Antrag (Pdf)</a>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class=" mb-3">
        <a href="/Export/Sepa/{{Auftrag.key}}" target="_blank" download="SEPA_{{Patient.versicherungsnummer}}.pdf">SEPA (Pdf)</a>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class=" mb-3">
        <a href="/Export/WechselErklaerung/{{Auftrag.key}}" target="_blank" download="WechselErklaerung_{{Patient.versicherungsnummer}}.pdf">WechselErklaerung (Pdf)</a>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class=" mb-3">
        <a href="/Export/Notfallplan/{{Auftrag.key}}" target="_blank" download="Notfallplan_{{Patient.versicherungsnummer}}.pdf">Notfallplan (Pdf)</a>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class=" mb-3">
        <a href="/Export/Mehrkosten/{{Auftrag.key}}" target="_blank" download="Mehrkostenerklärung_{{Patient.versicherungsnummer}}.pdf">Mehrkostenerklärung (Pdf)</a>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class=" mb-3">
        <a href="/Export/INBR/{{Auftrag.key}}" target="_blank" download="INBR_{{Patient.versicherungsnummer}}.pdf">INBR Formular (Pdf)</a>
      </div>
    </div>
  </div>
</div>
<hr />
<div class="FileList">
  @for (file of Files; track file.key) {
  <div class="row file">
    <a class="col" href="/Backend/File/{{file.key}}">{{file.name}}</a>
    <div class="col" (click)="ChangeType(file.key)">{{FileTypeEnum.find((element) => element.index == file.typ)?.Value}}</div>
    <div class="col-auto"> <i class="bi bi-trash3 DeleteButton" style="color:red;" (click)="DeleteFile(file.key)"></i></div>
  </div>
  }
</div>
<div class="row Upload">
  <div class="col">
    <div class="btn btn-primary" (click)="UploadFile()">Hochladen</div>
  </div>
</div>
@if(SelectetFile != null)
{
<div class="SelectTypeDialogmodal" tabindex="-1" (keyup.enter)="SaveTypeOrUpload()">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Datei Type</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="Close()"></button>
      </div>
      <div class="modal-body">
        <label for="selectIndex" class="form-label">Wähle einen Dateitypen:</label>

        <select id="selectIndex"
                class="form-select"
                [(ngModel)]="SelectetFile.typ"
                (change)="onSelectionChange(SelectetFile.typ)">

          <option *ngFor="let opt of FileTypeEnum; let i = index" [value]="opt.index" [disabled]="opt.Disabel" >
            {{ opt.Value }}
          </option>

        </select>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="SaveTypeOrUpload()">Auswählen</button>
      </div>
    </div>
  </div>
</div>
}
 }
